@if (isInitialized) {
  <oe-chart [period]="service.historyPeriod" [title]="component.alias">
    <oe-controller-ess-grid-optimized-charge-chart [chartTitle]="'GENERAL.CHARGE'| translate" [component]="component">
    </oe-controller-ess-grid-optimized-charge-chart>
    <ion-card-content class="underline">
      <ion-row class="ion-justify-content-center">
        <ion-item class="ion-text-center" style="width: 100%;" lines="none">
          <ion-icon color="primary" size="large" slot="start" name="alert-outline"></ion-icon>
          <ion-label class="ion-text-wrap">
            <small translate>
              EDGE.INDEX.WIDGETS.GRID_OPTIMIZED_CHARGE.HISTORY.PRIORITY_DESCRIPTION
            </small>
          </ion-label>
        </ion-item>
      </ion-row>
    </ion-card-content>
    <sellToGridLimitChart [chartTitle]="'GENERAL.GRID_SELL'| translate" [component]="component">
    </sellToGridLimitChart>
    <ion-card-content class="underline">
      <ion-row class="ion-justify-content-center">
        <ion-item class="ion-text-center" style="width: 100%;" lines="none">
          <ion-icon color="primary" size="large" slot="start" name="alert-outline"></ion-icon>
          <ion-label class="ion-text-wrap">
            <small translate>
              EDGE.INDEX.WIDGETS.GRID_OPTIMIZED_CHARGE.HISTORY.BATTERY_CHARGE_GRID_LIMIT_DESCRIPTION
            </small>
          </ion-label>
        </ion-item>
      </ion-row>
    </ion-card-content>
  </oe-chart>
}
